/**
 * Frontend configuration
 */

export const CONFIG = {
  // API endpoint (SSE streams and REST endpoints share the same origin)
  apiUrl: import.meta?.env?.VITE_API_URL || window.location.origin,

  // Default timeframe
  defaultTimeframe: '5m',

  // Greeks heatmap defaults (spread into GreeksHeatmapPlugin options — this is
  // the effective source for cell opacity range and bright color stops)
  greeksHeatmap: {
    maxOpacity: 0.72,    // Maximum cell opacity (magnitude reads via hue, not opacity)
    minOpacity: 0.40,    // Minimum cell opacity
    positiveColor: [59, 130, 246],  // Blue for positive GEX
    negativeColor: [249, 115, 22],  // Orange for negative GEX
  },

  // Available timeframes
  timeframes: ['1m', '5m', '15m', '30m', '1h', '4h', '1d'],

  // Volume candle sizes (contracts per candle)
  volumeCandleSizes: [5000, 10000],

  // Combined chart type options for dropdown
  chartTypes: [
    // Time-based candles
    { value: '1m', label: '1m', type: 'time' },
    { value: '5m', label: '5m', type: 'time' },
    { value: '15m', label: '15m', type: 'time' },
    { value: '30m', label: '30m', type: 'time' },
    { value: '1h', label: '1h', type: 'time' },
    { value: '4h', label: '4h', type: 'time' },
    { value: '1d', label: '1d', type: 'time' },
    // Volume-based candles
    { value: 'vol-5000', label: '5K Vol', type: 'volume', volumeSize: 5000 },
    { value: 'vol-10000', label: '10K Vol', type: 'volume', volumeSize: 10000 },
  ],
};

export default CONFIG;
